const googleDocsUrl = (url) =>
  `https://drive.google.com/viewer?embedded=true&url=${String(url)}`;

const isNonInteractivePreview = (data) => {
  return (
    (data.internetArchive && !data.internetArchivePreviewable) ||
    (!data.internetArchive &&
      (!data.httpsSecure || String(data.allowedInIframe) === 'false')) ||
    String(data.flashRequired) === 'true'
  );
};

export default { googleDocsUrl, isNonInteractivePreview };
